"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _AssetActivityDetailsHeaderComponent = _interopRequireDefault(require("./AssetActivityDetailsHeaderComponent"));
var _positionActions = require("../../../redux/actions/positionActions");
var _retailTemplate = require("../../../routeTemplates/retailTemplate");
var _marginSelectors = require("../../../redux/margin/selectors/marginSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formSelector = (0, _reduxForm.formValueSelector)('order-history-filter');
var mapStateToProps = function mapStateToProps(state) {
  var productManifest = state.productManifest;
  var product = state.apexCore.product;
  var startDate = formSelector(state, 'startDate');
  var endDate = formSelector(state, 'endDate');
  return {
    product: product,
    productManifest: productManifest,
    formObj: state.form['order-history-filter'] || {
      values: {
        product: null
      }
    },
    initialValues: {
      product: null
    },
    buttonBackLink: _retailTemplate.walletsPath,
    startDate: startDate,
    endDate: endDate,
    MarginBorrowerEnabled: (0, _marginSelectors.marginBorrowerEnabledSelector)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectPositionAndSave: function selectPositionAndSave(productId) {
      return dispatch((0, _positionActions.selectPositionAndSave)(productId));
    },
    setEndDate: function setEndDate(value) {
      return dispatch((0, _reduxForm.change)('order-history-filter', 'endDate', value));
    },
    clearDate: function clearDate(fieldName) {
      return dispatch((0, _reduxForm.change)('order-history-filter', fieldName, null));
    },
    clearFilters: function clearFilters() {
      dispatch((0, _reduxForm.change)('order-history-filter', 'startDate', null));
      dispatch((0, _reduxForm.change)('order-history-filter', 'endDate', null));
    }
  };
};
var container = (0, _reduxForm.reduxForm)({
  form: 'order-history-filter',
  onSubmit: function onSubmit() {}
})(_AssetActivityDetailsHeaderComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(container);